// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__A2Zxn","image":"Header_image__3qQeU","name":"Header_name__1EE54","info":"Header_info__2iZwV","infoRow":"Header_infoRow__2nFiL"};